import styled from "styled-components"

export const StyledAboutContactRightBar = styled.div`
  padding-right: 40px;
  @media only screen and (max-width: 767px) {
    padding-right: 0;
  }
  @media only screen and (max-width: 400px) {
    width: 100%;
  }
`
